module.exports = __webpack_public_path__ + "static/img/faqs6.7422727.png";